import { createSelector } from '@reduxjs/toolkit';

import { namespace as partnerNamespace } from '@/modules/partner/namespace';
import { namespace as userNamespace } from '@/modules/user/namespace';
import type { RootState } from '@/root-store';
import { CountryCode } from '@/shared/models/country-code';

const countryOrder: string[] = [
  CountryCode.GreatBritain,
  CountryCode.France,
  CountryCode.ArabEmirates,
  CountryCode.Russia,
  CountryCode.UnitedStates,
];

const getCountryCode = createSelector(
  (state: RootState) => state.partner.data.cityId,
  (state: RootState) => state.user.data.cityId,
  (state: RootState) => state.common.cities,

  (cityId, userCityId, cities) => {
    const cityToSearch = cityId || userCityId;

    return cities.find(city => city.id === cityToSearch)?.countryCode ?? CountryCode.Unknown;
  },
);

const getCities = createSelector(
  (state: RootState) => state.common.cities,
  cities =>
    [...cities].sort((city1, city2) => {
      const idx1 = countryOrder.indexOf(city1.countryCode);
      const idx2 = countryOrder.indexOf(city2.countryCode);

      if (idx1 > idx2) {
        return 1;
      }

      if (idx1 < idx2) {
        return -1;
      }

      return 0;
    }),
);

const getCitiesForOnboarding = createSelector(getCities, cities =>
  cities.filter(city => city.isEnabledForOnboarding),
);

const getCityName = (state: RootState) =>
  state[partnerNamespace].data.cityName || state[userNamespace].data.cityName;

export { getCountryCode, getCities, getCityName, getCitiesForOnboarding };
